import { formatDateTime } from '../../format-converter/utils';
import { formatBytes } from '../utils';

function StoragePropertiesModal({ item, onClose }) {
  if (!item) return null;

  return (
    <div className="fixed inset-0 z-[95] flex items-center justify-center bg-slate-900/35 p-4">
      <div className="w-full max-w-lg rounded-2xl border border-slate-200 bg-white p-5 shadow-2xl">
        <h3 className="text-base font-bold text-slate-900">Properties</h3>
        <div className="mt-3 grid gap-2 rounded-lg border border-slate-200 bg-slate-50 p-3 text-sm text-slate-700">
          <p><span className="font-semibold">Name:</span> {item.name || '-'}</p>
          <p><span className="font-semibold">Type:</span> {item.type || '-'}</p>
          <p><span className="font-semibold">Size:</span> {item.type === 'file' ? formatBytes(item.size) : '-'}</p>
          <p><span className="font-semibold">Updated:</span> {formatDateTime(item.updatedAt)}</p>
          <p><span className="font-semibold">Content Type:</span> {item.contentType || '-'}</p>
          <p><span className="font-semibold">Path:</span> <span className="break-all">{item.storagePath || '-'}</span></p>
          <p><span className="font-semibold">Status:</span> {item.status || '-'}</p>
        </div>
        <div className="mt-4 flex justify-end">
          <button
            type="button"
            className="rounded-lg bg-slate-900 px-3 py-2 text-sm font-semibold text-white transition hover:bg-slate-700"
            onClick={onClose}
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
}

export default StoragePropertiesModal;
